<template>
  <modal
    title="Create New Loyalty Scheme"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <div>
        <label class="label">Loyalty Name:</label>
        <input
          type="text"
          class="input"
          placeholder="Enter"
          v-model="scheme.loyaltyCategory"
        />
      </div>
      <div class="">
        <label class="label">Discount Rate (%):</label>
        <input
          type="number"
          class="input"
          @keypress="isNumber($event)"
          placeholder="Enter"
          v-model="scheme.discountRate"
        />
      </div>
      <div class="actions pt-4 flex justify-between">
        <div class="cursor-pointer" @click="closeModal">
          <p>Cancel</p>
        </div>
        <div>
          <primary-button
            buttonText="Save"
            :loading="loading"
            @click="createLoyaltyScheme"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      scheme: {
        loyaltyCategory: "",
        discountRate: 0,
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async createLoyaltyScheme() {
      this.loading = true;
      const orgId = localStorage.getItem("organizationId");
      const payload = {
        userInfo: {
          orgId: orgId,
          outletId: null,
          creatorId: orgId,
        },
        payload: this.scheme,
      };
      payload.payload.discountRate = Number(payload.payload.discountRate);
      try {
        const response = await this.$_createLoyaltyScheme(payload);
        this.logResponse(response);
        this.generateToast("Loyalty scheme created successfully!", "success");
        this.$emit("scheme-created");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  display: none;
}
</style>
